import { SET_DAYEND_POPUP, RESET_DAYEND_POPUP, SET_DAYEND_STATE } from "../types/dayEndTypes";

export interface DayEndReducerState {
  dayEndPopupState: boolean;
  dayEndState: any;
}

const initialState: DayEndReducerState = {
  dayEndPopupState: false,
  dayEndState: {}
};


const dayEndReducer = (state = initialState, action: any): DayEndReducerState => {
    switch (action.type) {
        case SET_DAYEND_POPUP:
            console.log("Action Payload:", action.payload);
            return { ...state, dayEndPopupState: action.payload };
        case RESET_DAYEND_POPUP:
            return initialState;
        case SET_DAYEND_STATE:
          return {...state, dayEndState: action.payload}
        default:
            return state;
    }
};

export default dayEndReducer;
